import { FC, useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { LineChart } from '../../../../../components/Charts/LineChart/LineChart';
import { IMetricsDataModel } from '../../../../../data-models/metrics.data-model';
import { sectorsColourState } from '../../../../../services/state/SectorStateJ';
import { CHART_COMPONENTS } from '../../../../../types';
import { IPortfolioChartProps } from '../ChartComponent';
import { allChartItems } from '../ChartsSection';
import { useMoicBySector } from './useMoicBySector';

export const MoicBySectorChart: FC<IPortfolioChartProps<IMetricsDataModel>> = (props) => {
  const { data } = useMoicBySector(props.filteredMetrics);
  const yFormatter = useCallback((tick: number | string) => `${Number(tick).toFixed(1)} x`, []);
  const sectorColours = useAtomValue(sectorsColourState);

  return (
    <LineChart
      chartColors={sectorColours}
      data={data}
      id={CHART_COMPONENTS.MOIC_BY_SECTOR}
      title={allChartItems.get(CHART_COMPONENTS.MOIC_BY_SECTOR)?.value ?? 'MOIC by Sector'}
      width={640}
      yAxisLabelFormatter={yFormatter}
      isFullScreen={props.isFullScreen}
      onOpenFullScreen={props.onOpenFullScreen}
    />
  );
};
